import PaginatedList from "#root/components/paginated-list";
import { getInvoiceCollectionForAccount } from "#root/schema/invoices";
import formatNumber from "cloudquote-number-format";
import type { ReactNode } from "react";
import PageLayout from "./layout";

const invoiceCollection = getInvoiceCollectionForAccount("self");

export default function BillingInvoicesPage(): ReactNode {
  return (
    <PageLayout title="Billing - Invoices">
      <section>
        <h1>Invoices</h1>
        <p>View and download your billing invoices. Each invoice includes a breakdown of charges and a link to the PDF.</p>

        <PaginatedList title="Latest Invoices" collection={invoiceCollection} allowSearch={false}>
          {({ rows }) => {
            let lastYear: number | null = null;
            const elements: ReactNode[] = [];

            for (const { id, date, total, paid, pdfLink } of rows) {
              const year = new Date(date).getUTCFullYear();

              if (year !== lastYear) {
                elements.push(
                  <tr key={"divider-" + year}>
                    <td colSpan={6} className="label-divider">
                      {year} Invoices
                    </td>
                  </tr>,
                  <tr key={"header-" + year}>
                    <th>Ref</th>
                    <th>Date</th>
                    <th>Total</th>
                    <th>Due</th>
                    <th>Action</th>
                  </tr>,
                );
                lastYear = year;
              }

              elements.push(
                <tr key={id}>
                  <td>CI-{id}</td>
                  <td>{date}</td>
                  <td>{formatNumber(Number(total), { Comma: true, Prefix: "$", Decimals: 0, Default: "N/A" })}</td>
                  <td>{formatNumber(Number(total) - Number(paid), { Comma: true, Prefix: "$", Decimals: 0, Default: "N/A" })}</td>
                  <td>
                    <a target="_blank" href={pdfLink} rel="noopener">
                      View Invoice
                    </a>
                  </td>
                </tr>,
              );
            }

            return (
              <table>
                <tbody>{elements}</tbody>
              </table>
            );
          }}
        </PaginatedList>
      </section>
    </PageLayout>
  );
}
